import React from 'react';
import {HStack, Text, VStack} from '@tempo/core';
import type {TdProps} from '@components/Table/core/Td';
import Td from '@components/Table/core/Td';
import Thumbnail from '@components/Thumbnail';
import {ContentType} from '@deezer/next/services/types/contentType';
import type {Release} from '@deezer/next/services/api/Starmania/requests/album/types';
import {AlbumStatus} from '@deezer/next/services/api/Starmania/requests/album/types';

type ArtistDiscographyTitleCellProps = {
	release: Release;
} & TdProps;

const ArtistDiscographyTitleCell = ({
	release,
	...rest
}: ArtistDiscographyTitleCellProps) => {
	const {id, picture, title, url, status} = release;

	return (
		<Td whiteSpace="pre-wrap" {...rest}>
			<HStack spacing="spacing.m">
				<Thumbnail
					id={String(id)}
					picture={picture}
					type={ContentType.Artist}
					rounded={true}
					coverLink={status === AlbumStatus.LIVE}
					redirectUrl={url}
					width={'32px'}
					height={'32px'}
				/>
				<VStack align="left" spacing="spacing.xs">
					<Text
						variant="body.small.regular"
						color="text.neutral.primary.default"
						noOfLines={1}
						wordBreak="break-all"
						data-testid="artist-name-cell-title"
					>
						{title}
					</Text>
				</VStack>
			</HStack>
		</Td>
	);
};

export default ArtistDiscographyTitleCell;
